import * as React from "react";
import {cx} from "emotion";

import "./agree-responsibility.scss";

import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {UseState}         from "@Common/react/use-state";
import {isDevQuan}        from "@Common/ui-components/debug/is-dev-quan";
import {Checkbox}         from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {AgreementModal} from "@Xpresso/routes/common/agreement-modal/agreement-modal";

export const AgreeResponsibility = ({next}) => cs(
    ["agreed", (_, next) => UseState({
        initValue: isDevQuan(),
        next,
    })],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ["agreementModal", ({}, next) => AgreementModal({agreementGroupName: "scheduled_campaigns", next})],
    ({agreed, eh, domRef, agreementModal}) => next({
        enrollmentEditor: agreementModal.available && {
            $name: "AgreeResponsibility",
            valid: agreed.value,
            errorsHandling: {
                highlightErrors: () => {
                    eh.start();
                    scrollIntoView(domRef.get());
                },
            },
        },
        render: () => agreementModal.available && (
            <div {...{
                className: "agree-responsibility-6cs",
            }}>
                <div {...{
                    className: cx("box", eh.css),
                    onClick: () => agreed.change(v=>!v),
                    ref: domRef.set,
                }}>
                    {Checkbox({
                        checked: agreed.value,
                        xdQaName: "Agree to the terms and conditions",
                    })}
                    <div className="label">
                        I agree to the{" "}

                        <a {...{
                            onClick: (e) => {
                                e.stopPropagation();
                                agreementModal.show({
                                    onYes: async () => {
                                        agreed.onChange(true);
                                    }
                                });
                            },

                            "xd-qa-type": "link",
                            "xd-qa-name": "terms and conditions",
                        }}>
                            terms and conditions
                        </a>
                        {" "}

                        of this program.
                    </div>
                </div>
            </div>
        ),
    }),
);
